import { render, staticRenderFns } from "./jpWriterStatus.vue?vue&type=template&id=38378958&scoped=true&"
import script from "./jpWriterStatus.vue?vue&type=script&lang=js&"
export * from "./jpWriterStatus.vue?vue&type=script&lang=js&"
import style0 from "./jpWriterStatus.vue?vue&type=style&index=0&id=38378958&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38378958",
  null
  
)

export default component.exports